import { render, staticRenderFns } from "./Shortcuts.vue?vue&type=template&id=669f1b23&scoped=true"
import script from "./Shortcuts.vue?vue&type=script&lang=js"
export * from "./Shortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f1b23",
  null
  
)

export default component.exports